var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import ChatBotV3 from './chatBotV3/ChatBotV3';
import ChatBotV2 from './chatBotV2/ChatBotV2';
import { GilroyProvider } from './GilroyContext';
import GilRoyV1Style from './GilroyV1Style';
import store from '../Store';
import { Provider } from 'react-redux';
import ToasterNotification from './common/components/ToasterNotification';
var Gilroy = function (props) {
    var gilroyStates = props.gilroyStates, gilroyActions = props.gilroyActions, isGilroyV2 = props.isGilroyV2, tagItem = props.tagItem, getStatesAndActions = props.getStatesAndActions, children = props.children;
    return (_jsxs(Provider, __assign({ store: store }, { children: [_jsx(GilRoyV1Style, {}), _jsx(ToasterNotification, {}), _jsx(GilroyProvider, __assign({ gilroyStates: gilroyStates, gilroyActions: gilroyActions }, { children: isGilroyV2 ? _jsx(ChatBotV2, __assign({ tagItem: tagItem }, { children: children })) : _jsx(ChatBotV3, { tagItem: tagItem }) }))] })));
};
export default Gilroy;
